import * as React from 'react';
import { style } from '@project/store/Legend';

function getColor(color: style.Color) {
  if (typeof color === 'string') {
    return color;
  } else if (typeof color === 'object') {
    let { r, g, b, a } = color;

    return `rgba( ${[r, g, b, a].join(',')} )`;
  }

  return;
}

export interface ClusterItemProps {
  style: style.LayerClustermapStyle;
  iconStyle?: React.CSSProperties;
}

export const ClusterStyleLegend: React.FC<ClusterItemProps> = ({
  style,
  iconStyle = {},
}) => {
  const backgroundColor = style?.point?.circle?.style.fill.color || 'white';

  const backgroundImage = style?.point?.circle?.style.fill.pattern?.img;

  const borderColor = style?.point?.circle?.style.border.color || 'black';

  const borderWidth = style?.point?.circle?.style.border.width || 2;

  const icon = style?.point?.icon?.src;

  const textColor = style?.text?.fill || 'black';

  return (
    <>
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '5px',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            backgroundColor: getColor(backgroundColor),
            backgroundImage: `url(${backgroundImage || icon})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            border: icon
              ? ''
              : `${borderWidth}px solid ${getColor(borderColor)}`,
            ...iconStyle,
          }}
        >
          <strong style={{ color: getColor(textColor) }}>N</strong>
        </span>
      </span>
    </>
  );
};
